<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="{ [item.className]: true }"
      v-html="props[item.valueKey]"
    ></div>
    <div v-html="svg" class="svg"></div>
  </div>
</template>

<script setup lang="tsx">
import { withDefaults, defineProps, defineEmits } from 'vue';

import { vMove, vInput, useCover } from './index';
type Pos = {
  left: number;
  top: number;
  center?: boolean;
  initHeight?: number;
  left2right?: boolean;
};
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const emits = defineEmits(['posChange', 'valueChange']);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1194.766 1110.189">
  <g transform="translate(2 -573.811)">
    <path d="M-617,793.928S-41.064,996.68,201.785,1051.316c4.272.961,8.383,1.877,12.4,2.761,236.222,52.023,361.582,0,361.582,0v748.905H-617Z" transform="translate(617 -121.244)" fill="var(--theme-color-1)" opacity="0.409"/>
    <path d="M1941.034,994.8H749.5V-115c2.267.472,4.56.989,6.817,1.535,12.54,3.033,25.744,6.716,39.243,10.946,13.214,4.14,27.076,8.919,41.2,14.2,27.321,10.221,56.738,22.748,87.433,37.233,29.267,13.811,60.47,29.767,92.742,47.425,30.657,16.775,63.081,35.524,96.37,55.726,115.162,69.891,245.754,160.091,388.149,268.094,55.94,42.43,113.86,87.743,172.15,134.683,46.632,37.551,93.6,76.22,139.609,114.934,78.389,65.962,127.335,109.669,127.82,110.1V994.794Z" transform="translate(-751 688.811)" fill="var(--theme-color-1)" opacity="0.458"/>
    <path d="M-617,874.879s359.179,76.462,573.7,150.936,619.685,284.138,619.685,284.138v488.941H-617Z" transform="translate(615 -114.895)" fill="var(--theme-color-1)"/>
  </g>
</svg>
`;

const { info, onPosChange, onValueChange } = useCover(emits);
</script>
<style lang="scss" scoped>
.cover {
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
}
.svg {
  width: calc(100% + 0px);
  position: absolute;
  left: 0px;
  bottom: 10px;
}

.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
  text-align: right;
}
.project-name,
.time {
  font-size: 63px;
  font-weight: 600;
  color: #404040;
}

.project-name {
  max-width: 750px;
  min-width: 500px;
}
.time {
  font-size: 36px;
  min-width: 250px;
  max-width: 690px;
  color: #484848;
}
.enterprise-name {
  font-size: 36px;
  font-weight: 600;
  max-width: 600px;
  min-width: 450px;
  color: #fff;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #484848;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
